<template>
    <section class="container container-content">
        <a-card>
            <a-row :gutter="[16, 24]">
                <a-col :md="24" :lg="8">
                    <a-form-item>

                        <template slot="label">
                            <span>Фамилия</span>
                            
                            <a-tooltip title="Укажите фамилию персоны">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.surname"
                            :allowClear="true"
                            placeholder="Укажите фамилию"
                            style="width: 100%"
                            @search="autocomplete('surname', 'surnames', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in surnames"
                                    :key="index"
                                    :value="value.surname"
                                >{{ value.surname }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="8">
                    <a-form-item>
                        <template slot="label">
                            <span>Имя</span>
                            
                            <a-tooltip title="Укажите имя персоны">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.name"
                            :allowClear="true"
                            placeholder="Укажите имя"
                            style="width: 100%"
                            @search="autocomplete('name', 'names', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in names"
                                    :key="index"
                                    :value="value.name"
                                >{{ value.name }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="8">
                    <a-form-item>
                        <template slot="label">
                            <span>Отчество</span>
                            
                            <a-tooltip title="Укажите отчество персоны">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.patronymic"
                            :allowClear="true"
                            placeholder="Укажите отчество"
                            style="width: 100%"
                            @search="autocomplete('patronymic', 'patronymics', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in patronymics"
                                    :key="index"
                                    :value="value.patronymic"
                                >{{ value.patronymic }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="8">
                    <a-form-item>
                        <template slot="label">
                            <span>Событие</span>

                            <a-tooltip title="Выберите событие">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-select v-model="data.event"
                            :allowClear="true"
                            placeholder="Выберите событие"
                            show-search
                            style="width: 100%"
                        >
                            <a-select-option v-for="(data, index) in events"
                                :key="index"
                                :value="data.value"
                            >{{ data.label }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="4">
                    <a-form-item>
                        <template slot="label">
                            <span>Начальная дата</span>
                            
                            <a-tooltip title="Укажите начальную дату">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-input-number v-model="data.startYear"
                            :default-value="0"
                            :placeholder="'Укажите начальный год'"
                            style="width: 100%"
                        />
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="4">
                    <a-form-item>
                        <template slot="label">
                            <span>Конечная дата</span>
                            
                            <a-tooltip title="Укажите конечную дату">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-input-number v-model="data.endYear"
                            :default-value="0"
                            :placeholder="'Укажите конечный год'"
                            style="width: 100%"
                        />
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="8">
                    <a-form-item>
                        <template slot="label">
                            <span>Вероисповедание</span>

                            <a-tooltip title="Выберите вероисповедание из спсика">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-select v-model="data.creed"
                            :allowClear="true"
                            placeholder="Выберите вероисповедание"
                            show-search
                            style="width: 100%"
                        >
                            <a-select-option v-for="(data, index) in creeds"
                                :key="index"
                                :value="data.value"
                            >{{ data.label }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>

            <a-row :gutter="[16, 24]">
                <a-col :md="24" :lg="6">
                    <a-form-item>
                        <template slot="label">
                            <span>Губерния</span>
                            
                            <a-tooltip title="Укажите губернию">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.guberniya"
                            :allowClear="true"
                            placeholder="Укажите губернию"
                            style="width: 100%"
                            @search="autocomplete('guberniya', 'guberniyas', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in guberniyas"
                                    :key="index"
                                    :value="value.guberniya"
                                >{{ value.guberniya }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="6">
                    <a-form-item>
                        <template slot="label">
                            <span>Уезд</span>
                            
                            <a-tooltip title="Укажите уезд">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.uezd"
                            :allowClear="true"
                            placeholder="Укажите уезд"
                            style="width: 100%"
                            @search="autocomplete('uezd', 'uezds', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in uezds"
                                    :key="index"
                                    :value="value.uezd"
                                >{{ value.uezd }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="6">
                    <a-form-item>
                        <template slot="label">
                            <span>Волость</span>
                            
                            <a-tooltip title="Укажите волость">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.volost"
                            :allowClear="true"
                            placeholder="Укажите волость"
                            style="width: 100%"
                            @search="autocomplete('volost', 'volosts', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in volosts"
                                    :key="index"
                                    :value="value.volost"
                                >{{ value.volost }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>

                <a-col :md="24" :lg="6">
                    <a-form-item>
                        <template slot="label">
                            <span>Населенный пункт</span>
                            
                            <a-tooltip title="Укажите населенный пункт">
                                <a-icon type="info-circle" style="color: rgba(0, 0, 0, .45)" />
                            </a-tooltip>
                        </template>

                        <a-auto-complete v-model="data.settlement"
                            :allowClear="true"
                            placeholder="Укажите населенный пункт"
                            style="width: 100%"
                            @search="autocomplete('settlement', 'settlements', 3, ...arguments)"
                        >
                            <template slot="dataSource">
                                <a-select-option v-for="(value, index) in settlements"
                                    :key="index"
                                    :value="value.settlement"
                                >{{ value.settlement }}
                                </a-select-option>
                            </template>
                        </a-auto-complete>
                    </a-form-item>
                </a-col>
            </a-row>

            <a-row 
            :gutter="[16, 50]">
                <a-col :span="12" >
                    <a-button size="large"
                        style="margin-right: 8px"
                        @click="visibleHelp = true"
                    >Справка
                    </a-button>
                </a-col>

                <a-col :span="12"
                    class="d-flex justify-content-end"
                >
                    <a-button 
                        size="large"
                        style="margin-right: 8px"
                        type="primary"
                        @click.stop.prevent="clear"
                    >Очистить форму
                    </a-button>

                    <a-button 
                        size="large"
                        type="primary"
                        @click.stop.prevent="search"
                    >Поиск
                    </a-button>
                </a-col> 
            </a-row>

            <a-row v-if="persons && persons.length"
                :gutter="[16, 50]"
            >
                <a-col>
                    <a-collapse v-for="(person, index) in persons"
                        :key="index"
                        expand-icon-position="right"
                        style="margin-bottom: 20px"
                        @change="searchPerson(person.table, person.tableId, index)"
                    >
                        <a-collapse-panel :key="person.id">
                            <template slot="header">
                                <a-row>
                                    <a-col :span="12">
                                        <div v-if="person.surname || person.name">
                                            <strong>
                                            <span v-if="person.surname">{{ person.surname }} </span>
                                            <span v-if="person.name">{{ person.name }}</span>
                                            </strong>
                                        </div>

                                        <div v-else>
                                            <strong>Фамилия и имя не известны</strong>
                                        </div>

                                        <div v-if="person.fatherSurname">
                                            <span>Фамилия отца: {{ person.fatherSurname }}</span>
                                        </div>

                                        <div v-if="person.motherMaidenSurname">
                                            <span>Девичья фамилия матери: {{ person.motherMaidenSurname }}</span>
                                        </div>
                                    </a-col>

                                    <a-col align="end">
                                        <div>
                                            <strong>Вероисповедание: {{ setLabelCreed(person.creed) }}</strong>
                                        </div>

                                        <div>
                                            <strong>Раздел: «{{ setLabelSection(person.event) }}»</strong>
                                        </div>
                                    </a-col>
                                </a-row>
                            </template>

                            <div v-for="(block, index) in person.data"
                                :key="index"
                            >
                                <a-row style="padding-bottom: 20px">
                                    <a-col :span="24">
                                        <strong>{{ block.group }}</strong>
                                    </a-col>

                                    <a-col v-for="(field, jndex) in block.fields"
                                        :key="jndex"
                                        :span="24"
                                    >
                                        <strong style="padding-left: 20px">{{ field.label }}:</strong> {{ field.value }}
                                    </a-col>
                                </a-row>
                            </div>
                        </a-collapse-panel>
                    </a-collapse>
                </a-col>

                <a-col>
                    <a-pagination :default-current="1"
                        :hideOnSinglePage="true"
                        :show-size-changer="true"
                        :showQuickJumper="true"
                        :total="count"
                        @change="changePage"
                        @showSizeChange="changePageSize"
                    />
                </a-col>
            </a-row>
        </a-card>

        <modal-help :visible="visibleHelp"
            @cancel="visibleHelp = false"
        />

        <loading :active.sync="loading" 
            :is-full-page="true"
            :can-cancel="canCancel"
        />
    </section>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import helpModal from '../modal/help';


    export default {
        data() {
            return {
                ascending: 'ASC',
                canCancel: true,
                count: 0,
                creeds: [{
                    label: 'Ислам',
                    value: 'Islam'
                }, {
                    label: 'Иудаизм',
                    value: 'Judaism'
                }, {
                    label: 'Католицизм',
                    value: 'Catholicism'
                }, {
                    label: 'Лютеранство',
                    value: 'Lutheranism'
                }, {
                    label: 'Православие',
                    value: 'Orthodoxy'
                }, {
                    label: 'Старообрядчество',
                    value: 'Old Believers'
                }],
                data: {},
                events: [{
                    label: 'Брак',
                    value: 'marriage',
                    section: 'О бракосочетавшихся'
                }, {
                    label: 'Развод',
                    value: 'divorce',
                    section: 'О разведенных'
                }, {
                    label: 'Рождение',
                    value: 'birth',
                    section: 'О родившихся'
                }, {
                    label: 'Смерть',
                    value: 'death',
                    section: 'Об умерших'
                }],
                guberniyas: [],
                limit: 10,
                loading: false,
                names: [],
                orderBy: 'name',
                page: 1,
                patronymics: [],
                persons: null,
                settlements: [],
                surnames: [],
                uezds: [],
                visibleHelp: false,
                volosts: [],
            }
        },
        methods: {
            async search() {
                const vm = this;

                vm.persons = [];
                await vm.getPersons();
            },
            async changePage(page, pageSize) {
                const vm = this;

                vm.page = page;
                vm.limit = pageSize;
                await vm.getPersons();
            },
            async changePageSize(page, pageSize) {
                const vm = this;

                vm.page = page;
                vm.limit = pageSize;
                await vm.getPersons();
            },
            clear() {
                this.data = {};
                this.persons = [];
            },
            async autocomplete(slug, object, minLength, value) {
                const vm = this;

                if (value.length >= minLength) {
                    try {
                        const {data} = await vm.$axios.get(`/dictionary/${slug}`, {
                            params: {
                                value: value
                            }
                        });

                        vm.$set(vm, object, data);
                    } catch (error) {
                        this.$notification.error({
                            message: 'Ошибка',
                            description: 'Ошибка загрузки данных',
                            placement: 'topRight'
                        });
                    };
                };
            },
            async searchPerson(table, tableId, index) {
                const vm = this;

                vm.loading = true;

                try {
                    const {data} = await vm.$axios.get(`/persons/${table}/${parseInt(tableId)}`);
                    vm.$set(vm.persons[index], 'data', data);
                } catch (error) {
                    vm.$notification.error({
                        message: 'Ошибка загрузки данных',
                        description: 'Ошибка загрузки данных',
                        placement: 'topRight'
                    });
                };

                vm.loading = false;
            },
            async getPersons() {
                const vm = this;

                vm.loading = true;

                try {
                    const {data} = await vm.$axios.get('/persons', {
                        params: {
                            query: vm.data,
                            orderBy: vm.orderBy,
                            ascending: vm.ascending,
                            limit: vm.limit,
                            page: vm.page
                        }
                    });

                    vm.persons = data.persons;
                    vm.count = data.count;
                } catch(error) {
                    vm.$notification.error({
                        message: 'Ошибка загрузки данных',
                        description: 'Ошибка загрузки данных',
                        placement: 'topRight'
                    });
                }

                vm.loading = false;
            },
            setLabelCreed(value) {
                return this.creeds.find((x) => {
                    return x.value === value;
                }).label;
            },
            setLabelSection(value) {
                return this.events.find((x) => {
                    return x.value === value;
                }).section;
            }
        },
        components: {
            'loading': Loading,
            'modal-help': helpModal
        }
    };
</script>

<style>
    .ant-form-item {
        margin-bottom: 0;
    }
    .ant-form-item label:after {
        content: none;
    }
    .ant-form-item label {
        display: flex;
        flex-basis: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .ant-form-item-label {
        line-height: 20px;
        display: flex;
        width: 100%
    }
    .ant-carousel {
        margin: 30px 0;
    }
    .to-top {
        background: #f5f5f5;
        border-radius: 2px;
        border: 1px solid #222222;
        bottom: 50px;
        color: #444;
        cursor: pointer;
        display: block;
        height: 40px;
        line-height: 40px;
        position: fixed;
        right: 40px;
        text-align: center;
        width: 40px;
        z-index: 9999;
        transition: all .3s, 
    }
    .container-content {
        margin-bottom: 50px
    }
    /* .ant-form-item-children {
        width: 100%;
        display: flex;
        justify-content: space-between;
    } */
</style>

<style scoped>
    .ant-carousel >>> .slick-track {
        display: flex;
        align-items: center;
    }
    .ant-carousel >>>  img {
        max-height: 160px;
        max-width: 100%;
    }
    .ant-carousel >>> .custom-slick-arrow {
        width: 25px;
        height: 25px;
        font-size: 25px;
        color: #000000;
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
    }
    .ant-carousel >>> .custom-slick-arrow:before {
        display: none;
    }
    .ant-carousel >>> .custom-slick-arrow:hover {
        opacity: 0.5;
    }
    .ant-carousel >>> .slick-slide {
        display: flex;
        justify-content: center;
        text-align: center;
    }
    .ant-carousel >>> .slick-dots-bottom {
        bottom: -5px
    }
</style>